import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import sprite from '../../img/sprites.svg';
import { CertificatesContext } from '../../contexts/certificates.context';

import './certificate-new.style.scss';

const NO_FILL = { fill: 'none' };

export const CapIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 9.5 12 4.5l10 5-10 5z" style={NO_FILL} />
    <path d="M6 11.5v4.8c3.3 2.3 8.7 2.3 12 0v-4.8" style={NO_FILL} />
    <path d="M22 9.5v5" style={NO_FILL} />
  </svg>
);

CapIcon.propTypes = { className: PropTypes.string };
CapIcon.defaultProps = { className: '' };

const STATE = {
  done: { className: 'is-done', text: 'Отримано' },
  ready: { className: 'is-ready', text: 'Можна отримати' },
  wait: { className: 'is-wait', text: 'Після курсу' },
};

const CertificateRow = ({ programId, programTitle, progress, lessonsLeft, lesson }) => {
  const { byProgram, setOpenProgram } = useContext(CertificatesContext);
  const item = byProgram[programId] ?? null;
  const state = item?.issued ? STATE.done : item?.can_issue ? STATE.ready : STATE.wait;

  return (
    <button
      type="button"
      className={`certificate-row ${state.className}`}
      onClick={() => setOpenProgram({ id: programId, title: programTitle, progress, lessonsLeft, lesson })}
    >
      <span className="certificate-row__icon"><CapIcon className="certificate-row__svg" /></span>
      <span className="certificate-row__text">
        <span className="certificate-row__label">Сертифікат</span>
        <span className="certificate-row__state">{state.text}</span>
      </span>
      <svg className="certificate-row__arrow" aria-hidden="true"><use href={`${sprite}#arrow`}></use></svg>
    </button>
  );
};

CertificateRow.propTypes = {
  programId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  programTitle: PropTypes.string,
  progress: PropTypes.number,
  lessonsLeft: PropTypes.number,
  lesson: PropTypes.object,
};

CertificateRow.defaultProps = {
  programTitle: '',
  progress: 0,
  lessonsLeft: null,
  lesson: null,
};

export default CertificateRow;
